import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { getCookie } from '../helpers/helpers';

// Dependencies
import LogRocket from 'logrocket';

// Components
import HeaderOutside from './Common/HeaderOutside';
import Loader from './Common/Loader';
import Dialog from './Common/Dialog';
import Confirm from './Common/Confirm';
import Toaster from './Common/Toaster';
import Notification from './Common/Notification';
import Prompt from './Common/Prompt';
import { config, setToken } from '../config';
import { LaunchDarkly, FeatureFlag } from 'react-launch-darkly';

// Store
import store from '../stores/';

class AppOutside extends React.Component {
  componentWillMount() {
    const { SessionStore } = store;

    // Add token to session storage
    if(SessionStore.hasSessionStorage) {
      sessionStorage.setItem('token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjA4MWRlMjUwLTc5NDUtMTFlNy1iMWJmLTE3NGY3MzhmNGRlMSIsInRpbWVvdXQiOjAsImNyZWF0ZV90aW1lIjoxNTAxODcyMzA1Mzk3fQ.UNaZHd7J01DzbnRmLUOOEL_ezw5LfDeVVmRuR5NwTso');
    } else {
      document.cookie = 'token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjA4MWRlMjUwLTc5NDUtMTFlNy1iMWJmLTE3NGY3MzhmNGRlMSIsInRpbWVvdXQiOjAsImNyZWF0ZV90aW1lIjoxNTAxODcyMzA1Mzk3fQ.UNaZHd7J01DzbnRmLUOOEL_ezw5LfDeVVmRuR5NwTso';
    }

    // Remove the token param from the URL
    // this.props.router.push(this.props.location.pathname);

    // Check the token
    // this.checkToken();

    // Set token to api header
    if(SessionStore.hasSessionStorage) {
      setToken(sessionStorage.getItem('token'), true);
    } else {
      setToken(getCookie('token'), true);
    }

    // Get translations
    if(!SessionStore.translationLoaded) {
      SessionStore.getTranslation(SessionStore.locale);
    }
  }

  componentDidMount() {
    if(process.env.REACT_APP_ENVIRONMENT === 'production') {
      if(!store.SessionStore.logRocketInit) {
        LogRocket.init(config.logRocket);
        store.SessionStore.logRocketInit = true;
      }
    }
    window.addEventListener('message', event => {
      if (event.origin === config.domain && event.data === "SpRbScheduled__ConfirmBack") {
        const sourceWindow = event.source;
        sourceWindow.postMessage("SpRbScheduled__Confirmed", "*");
      }
    });
  }

  checkToken() {
    const { SessionStore } = store;
    SessionStore.checkToken();
  }

  render() {
    // Import styles
    if(!document.querySelector('link[href*="screen.css"]')) {
      const { highContrast } = store.SessionStore;

      let defaultStyles = document.createElement('link');
      defaultStyles.rel = `${highContrast ? 'alternate stylesheet' : 'stylesheet '}`;
      defaultStyles.type = 'text/css';
      defaultStyles.href = './static/css/screen.css';

      let highContrastStyles = document.createElement('link');
      highContrastStyles.rel = `${highContrast ? 'stylesheet' : 'alternate stylesheet'}`;
      highContrastStyles.type = 'text/css';
      highContrastStyles.href = './static/css/hi-c.css';

      document.head.appendChild(defaultStyles);
      document.head.appendChild(highContrastStyles);
    }

    // Detect touch device
    const docRoot = document.querySelector('html');
    if ('ontouchstart' in document.documentElement) {
      docRoot.classList.add('touch');
    }

    return (
      <div className="viewport">

         <LaunchDarkly clientId={config.ldApiKey} user={{key: 'anonymous-user', anonymous: true}}>          
          <FeatureFlag
              flagKey="maintenance-message"
              renderFeatureCallback={function(flagValue) {
                if(flagValue && typeof flagValue === 'object' && flagValue.message !== undefined){
                  // Redirect to maintenance page
                  window.location.href = `/#/maintenance`;
                  return null;
                }else{
                  return null;
                }
              }}
            />
        </LaunchDarkly>

        <HeaderOutside store={store} />

        {React.cloneElement(this.props.children, this.props)}

        {(store.SessionStore.loading || store.SessionStore.loadingClass) &&
          <Loader store={store} />
        }

        {store.SessionStore.dialog &&
          <Dialog store={store} />
        }

        {store.SessionStore.confirm &&
          <Confirm store={store} />
        }

        {store.SessionStore.prompt &&
          <Prompt store={store} />
        }

        {store.SessionStore.toaster &&
          <Toaster store={store} />
        }

        {store.SessionStore.notification &&
          <Notification store={store} {...this.props} />
        }
      </div>
    )
  }
}

export default observer(AppOutside);


// WEBPACK FOOTER //
// ./src/app/components/AppOutside.js